import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import { fetchWithAuth } from '../services/Fetch';
import Customer from '../interfaces/Customer';

const CustomersList: React.FC = () => {
    const [customers, setCustomers] = useState<Customer[]>([]);

    const fetchCustomers = async () => {
        try {
            const response = await fetchWithAuth('/customers');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setCustomers(data.member as Customer[]);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    return (
        <DefaultLayout>
            <h1>Clients</h1>
            <table className="table table-striped mt-3">
                <thead>
                    <tr>
                        <th scope="col">Nom</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {customers.map(customer => <tr key={customer.id}>
                        <td>{customer.title}</td>
                        <td>
                            <Link to={`/customers/${customer.id}`} className="btn btn-primary">
                                Voir le détail
                            </Link>
                            <Link to={`/customers/${customer.id}/edit`} className="btn btn-secondary ms-2">
                                Modifier
                            </Link>
                        </td>
                    </tr>)}
                </tbody>
            </table>
            <Link to="/customers/new" className="btn btn-success">Ajouter un client</Link>
        </DefaultLayout>
    );
}

export default CustomersList;